const validate = values => {
    const errors = {rutaId: ''};
    if (!values.rutaId) {
        errors.rutaId = 'Seleccione una ruta';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/almacen/validate.ts